// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Google Maps renders editable-polygon vertex handles as light-DOM divs; midpoint
 * ("ghost") handles get an inline opacity: 0.5 with no API option to change it.
 * Force full opacity so midpoints look the same as the edge vertices.
 */
.project-geofence-map .gm-style div[style*="opacity: 0.5"] {
    opacity: 1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/GoogleMaps/ProjectGeoFenceMap.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IACI,qBAAqB;AACzB","sourcesContent":["/*\n * Google Maps renders editable-polygon vertex handles as light-DOM divs; midpoint\n * (\"ghost\") handles get an inline opacity: 0.5 with no API option to change it.\n * Force full opacity so midpoints look the same as the edge vertices.\n */\n.project-geofence-map .gm-style div[style*=\"opacity: 0.5\"] {\n    opacity: 1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
